import React, {useEffect} from 'react';
import qs from "qs";
import commonSetting from '@/config/commonSetting'
import { useHistory } from 'react-router-dom';
import { searchPath } from '@/util/stringUtil.ts';

export default (prop) => {
  const history = useHistory()
  let query = qs.parse(history.location.search, { ignoreQueryPrefix: true })

  console.log('location.href', location.href)

  useEffect(()=>{
    let params = JSON.parse(query?.params)
    if (query.path) {
      let url = query.path;
      if(!url.startsWith("/")){
        url = "/" + url
      }
      let searchIndex = url.indexOf('?');
      if(params.accessToken || searchPath(commonSetting.WHITE_PAGE_LIST,  searchIndex>=0 ? url.slice(0, searchIndex) : url)){
        history.replace({
          pathname: searchIndex>=0 ? url.slice(0, searchIndex) : url,
          search: searchIndex>=0 && url.slice(searchIndex+1),
        })
      }else {
        history.replace({
          pathname: '/authorization',
          search: `path=${encodeURIComponent(url)}`,
        })
      }

    }
  }, [])

  return null;
};
